<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loadingFromApi">
                    <form @submit.prevent="">
                        <div class="form-group">
                            <label for="promotionInput">
                                Promotion Name
                            </label>
                            <div class="text-danger" v-if="promotion.promotionName.hasError">
                                {{ promotion.promotionName.errorMessage}}
                            </div>
                            <input type="text" placeholder="Promotion Name" class="form-control" id="promotionInput" v-model="promotion.promotionName.value">
                        </div>
                        <div class="form-group">
                            <label for="discountAmountInput">
                                Discount Amount
                            </label>
                            <div class="text-danger" v-if="promotion.discountAmount.hasError">
                                {{ promotion.discountAmount.errorMessage}}
                            </div>
                            <currency-input class="form-control" v-model="promotion.discountAmount.value"
                                            :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"
                                            @change="onDiscountAmountChange"></currency-input>
                        </div>
                        <div class="form-group">
                            <label for="promotionDescriptionInput">
                                Description
                            </label>
                            <div class="text-danger" v-if="promotion.promotionDescription.hasError">
                                {{ promotion.promotionDescription.errorMessage}}
                            </div>
                            <input type="text" placeholder="Description" class="form-control" id="promotionDescriptionInput" v-model="promotion.promotionDescription.value">
                        </div>
                        <div class="form-group">
                            <label>Active From Date</label>
                            <div class="text-danger" v-if="promotion.activeFromDate.hasError">
                                {{promotion.activeFromDate.errorMessage}}
                            </div>
                            <date-picker :format="'dd/MM/yyyy'" :elementId="'activeFromDatePicker'" :date="promotion.activeFromDate.value"
                                         :initialiseDate="initialiseActiveFromDate"
                                         @dateChange="onActiveFromDateSelect"></date-picker>
                        </div>
                        <div class="form-group">
                            <label>Active To Date</label>
                            <div class="text-danger" v-if="promotion.activeToDate.hasError">
                                {{promotion.activeToDate.errorMessage}}
                            </div>
                            <date-picker :format="'dd/MM/yyyy'" :elementId="'activeToDatePicker'" :date="promotion.activeToDate.value"
                                         :initialiseDate="initialiseActiveToDate"
                                         @dateChange="onActiveToDateSelect"></date-picker>
                        </div>
                        <h4>
                            Link Products To Promotion
                        </h4>
                        <div class="float-right">
                            <button class="btn btn-primary" @click="onLinkProductsClicked">
                                Link Products
                            </button>
                        </div>
                        <div class="text-danger" v-if="promotion.linkedProducts.hasError">
                            {{promotion.linkedProducts.errorMessage}}
                        </div>
                        <p>
                            Products Currently Linked
                        </p>
                        <data-table
                                :headings="productsToLinkHeadings"
                                :data="promotion.linkedProducts.value"
                                :hasActions="true"
                                :hasCustomActionComponent="true"
                                :hasNoFilter="true"
                                :hasNoPaging="true">
                            <template #actionComponent="{ productId }">
                                <button class="btn btn-link" @click="onPromotionUnlink(productId)">
                                    Unlink
                                </button>
                            </template>
                        </data-table>
                        
                        <button class="btn btn-primary mr-2" @click.prevent="addOrUpdatePromotion" :disabled="loading">Save</button>
                        <button class="btn btn-secondary" @click.prevent="onBackClick" :disabled="loading">Back</button>

                    </form>
                </div>
                <loading-spinner :showSpinner="loadingFromApi"></loading-spinner>
            </div>
        </div>
    </div>

    <error-modal :modalHeading="errorModal.modalHeading" 
                :elementId="errorModal.elementId" 
                :modalMessage="errorModal.modalMessage" 
                :showModal="errorModal.showModal"
                @okClicked="errorModelOkClicked"></error-modal>
    
    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModelOkClicked"></success-modal>
    
    <link-products-to-promotion-modal
        :heading="productsLinkingModal.modalHeading"
        :modalId="productsLinkingModal.modalComponentId"
        :showModal="productsLinkingModal.showModal"
        :productsLinkedToPromotion="promotion.linkedProducts.value"
        @saveClicked="onProductsLinkSaveClicked"
        @okClicked="onLinkProductsToPromotionModalOkClick"></link-products-to-promotion-modal>

</div>
